import utils from 'utils'
import manualEntryDialogCtrl from './manualEntryDialogCtrl'
import collectDialogCtrl from './collectDialogCtrl'

class customsPaymentListCtrl {
    constructor($scope, httpRequest, $uibModal, $state, logger, sweetalert, initSortService, getOvatAmtService, Upload, $timeout) {
        //获取当前税号的进项是否是电子税局，true 电子税
        httpRequest.get_getIsElecTaxBureau().then((res) => {
            $scope.isElecTaxBureau = res.data.value
        })
        // 当前机构的id
        $scope.currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
        $scope.importCollapsed = false
        // 手工录入弹窗
        function manualEntryDialog() {
            return $uibModal.open({
                templateUrl: 'manual-entry-dialog.html',
                controller: manualEntryDialogCtrl,
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-md',
                resolve: {},
            }).result
        }
        // 导入弹窗
        function importExcelDialog() {
            return $uibModal.open({
                templateUrl: 'import-excel-dialog.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    ($scope, $uibModalInstance) => {
                        // 批量导入
                        let iptFile = ''
                        $scope.uploadFiles = function uploadFiles(file, errFiles) {
                            if (file == null && errFiles.length >= 1) {
                                logger.logError('文件类型错误，文件大小不超过500kB，只支持.xls格式文件导入')
                                return
                            }
                            if (file) {
                                $scope.fileName = file.name
                                iptFile = file
                            }
                        }

                        // 模板下载
                        $scope.exportSetting = function exportSetting() {
                            window.open(`${host.etcloudIvatApp}/dl/dlTaskService/export_CUSTOM_PAYMENT_BATCH_IMPORT?accessToken=${localStorage.id_token}`)
                        }
                        // 错误弹框
                        const importErrorModal = function importErrorModal(batchNo) {
                            $uibModal.open({
                                templateUrl: 'importError.html',
                                controller: [
                                    '$scope',
                                    '$uibModalInstance',
                                    function ($scope, $uibModalInstance) {
                                        $scope.pageOptions = {
                                            currentPage: 1,
                                            maxSize: 10,
                                        }
                                        function queryList() {
                                            httpRequest
                                                .post_getPageDlBatchInfoList({
                                                    pageNum: $scope.pageOptions.currentPage,
                                                    pageSize: $scope.pageOptions.maxSize,
                                                    param: batchNo,
                                                })
                                                .then((res) => {
                                                    $scope.list = res.data.value.list
                                                    $scope.pageOptions = {
                                                        // 分页器
                                                        totalItems: res.data.value.total,
                                                        currentPage: ++res.data.value.prePage,
                                                        maxSize: res.data.value.pageSize,
                                                    }
                                                })
                                        }
                                        queryList()
                                        $scope.pageChanged = () => {
                                            queryList()
                                        }
                                        $scope.ok = () => {
                                            $uibModalInstance.close()
                                        }
                                    },
                                ],
                                backdrop: 'static',
                                openedClass: 'mod-modal-importexcel',
                                windowClass: 'mod-modal mod-modal-lg',
                                bindToController: true,
                                resolve: {},
                            })
                        }
                        $scope.ok = function ok() {
                            let file = iptFile
                            if (file) {
                                const data = {
                                    importFile: file,
                                    typeCode: 'CUSTOM_PAYMENT_BATCH_IMPORT',
                                }
                                file.upload = Upload.upload({
                                    url: `${host.etcloudIvatApp}dl/dlTaskService/importBill`,
                                    data,
                                })
                                // 文件上传
                                // loading动画
                                const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                                    time: 0,
                                    skin: 'layer-loading-self',
                                    icon: 16,
                                    shade: 0.5,
                                })
                                file.upload.then(
                                    (res) => {
                                        $timeout(() => {
                                            if (!res.data.success) {
                                                // 关闭loading
                                                layer.close(importinglayer)
                                                return logger.logError(res.data.message || '上传失败')
                                            }
                                            file.result = res.data
                                            const { batchNo } = file.result.value

                                            if (res.data.value.errorCount > 0) {
                                                layer.close(importinglayer)
                                                $uibModalInstance.close()
                                                importErrorModal(batchNo)
                                            }

                                            if (res.data.value.errorCount === 0) {
                                                const resultObj = res.data.value.resultObj
                                                if (resultObj) {
                                                    // 服务器版
                                                    if (resultObj.diskType === '2') {
                                                        window.layer.close(importinglayer)
                                                        logger.logSuccess('上传成功')
                                                        $uibModalInstance.close(true)
                                                    } else {
                                                        $.post({
                                                            url: `${resultObj.serverAddress}/InvDk`,
                                                            data: JSON.stringify({
                                                                SID: resultObj.sid,
                                                                SIDParam: resultObj.sidReqParam,
                                                            }),
                                                            contentType: 'application/json; charset=utf-8',
                                                            dataType: 'json',
                                                            success(json) {
                                                                if (json.retcode === '1') {
                                                                    httpRequest
                                                                        .post_writeBatchImportResult({
                                                                            type: '2',
                                                                            responseStr: json.ResponseStr,
                                                                            batchNo,
                                                                        })
                                                                        .then(() => {
                                                                            window.layer.close(importinglayer)
                                                                            logger.logSuccess('上传成功')
                                                                            $uibModalInstance.close(true)
                                                                        })
                                                                } else {
                                                                    window.layer.close(importinglayer)
                                                                    logger.logError(json.retmsg)
                                                                    $uibModalInstance.close()
                                                                }
                                                            },
                                                            error() {
                                                                window.layer.close(importinglayer)
                                                                logger.logError('进项服务连接失败')
                                                                $uibModalInstance.close()
                                                            },
                                                        })
                                                    }
                                                }
                                            }
                                        })
                                    },
                                    (response) => {
                                        if (response.status > 0) {
                                            // 关闭loading
                                            layer.close(importinglayer)
                                            logger.logError('上传失败 ')
                                        }
                                    }
                                )
                            } else {
                                logger.logError('请选择需要导入的文件')
                            }
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.dismiss()
                        }
                    },
                ],
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {},
            }).result
        }
        // 更新结果
        function updateResultsDialog() {
            return $uibModal.open({
                templateUrl: 'update-result-dialog.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'items1',
                    ($scope, $uibModalInstance, items1) => {
                        $scope.audit_result2 = items1
                        $scope.param = {
                            billId: '',
                            auditResult2: '',
                            billDate: '',
                            billDateEnd: '',
                            inputDateStart: '',
                            inputDateEnd: '',
                        }
                        $scope.ok = function ok() {
                            const { billId, auditResult2, billDate, billDateEnd, inputDateStart, inputDateEnd } = $scope.param

                            const layer = window.layer.msg('正在更新中, 请耐心等待', {
                                time: 0,
                                skin: 'layer-loading-self',
                                icon: 16,
                                shade: 0.5,
                            })

                            httpRequest
                                .post_updateAuditResult2({
                                    billId,
                                    auditResult2,
                                    billDate,
                                    billDateEnd,
                                    inputDateStart,
                                    inputDateEnd,
                                    type: '1',
                                })
                                .then((res) => {
                                    const _res = res.data.value
                                    if (_res) {
                                        // 服务器版
                                        if (_res.diskType === '2') {
                                            window.layer.close(layer)
                                            logger.logSuccess('更新成功')
                                            $uibModalInstance.close()
                                        } else {
                                            $.jsonp({
                                                url: `${_res.serverAddress}/InvDk`,
                                                data: {
                                                    SID: _res.sid,
                                                    SIDParam: _res.sidReqParam,
                                                },
                                                timeout: 86400000,
                                                charset: 'GBK',
                                                callbackParameter: 'callback',
                                                success(json) {
                                                    if (json.retcode === '1') {
                                                        httpRequest
                                                            .post_updateAuditResult2({
                                                                billId,
                                                                auditResult2,
                                                                billDate,
                                                                billDateEnd,
                                                                inputDateStart,
                                                                inputDateEnd,
                                                                type: '2',
                                                                responseStr: json.ResponseStr,
                                                            })
                                                            .then(() => {
                                                                window.layer.close(layer)
                                                                logger.logSuccess('更新成功')
                                                                $uibModalInstance.close()
                                                            })
                                                    } else {
                                                        window.layer.close(layer)
                                                        logger.logError(json.retmsg)
                                                        $uibModalInstance.close()
                                                    }
                                                },
                                                error() {
                                                    window.layer.close(layer)
                                                    logger.logError('进项服务连接失败')
                                                    $uibModalInstance.close()
                                                },
                                            })
                                        }
                                    }
                                })
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.dismiss()
                        }
                    },
                ],
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-md',
                resolve: {
                    items1() {
                        return $scope.dictionary.audit_result2
                    },
                },
            }).result
        }
        // 手工录入
        $scope.manualEntry = function manualEntry() {
            manualEntryDialog().then((res) => {
                if (res) {
                    sweetalert.confirm('提示', '请稍后点击“更新结果”，可查看本次的稽核结果，结果为“相符”的缴款书才允许勾选抵扣！')
                }
                $scope.queryList()
            })
        }
        // 导入
        $scope.importExcel = function importExcel() {
            importExcelDialog().then((res) => {
                if (res) {
                    sweetalert.confirm('提示', '请稍后点击“更新结果”，可查看本次的稽核结果，结果为“相符”的缴款书才允许勾选抵扣！')
                }
                $scope.queryList()
            })
        }
        // 更新结果
        $scope.updateResults = function updateResults() {
            updateResultsDialog().then(() => {
                $scope.queryList()
            })
        }

        // 导出
        $scope.exportExcel = function exportExcel() {
            const exportParam = $.extend({}, $scope.queryParam.param, {
                invoiceAccountIds: $scope.selectedRows.map((x) => x.billId).join(','),
            })
            const url = `${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/exportToExcel?accessToken=${localStorage.getItem('id_token')}`
            for (let i in $scope.queryParam.orderMap) {
                exportParam.sortField = i + ':' + $scope.queryParam.orderMap[i]
            }
            utils.post_downLoad(exportParam, url)
        }
        // 所属期
        const startDate = new Date()
        startDate.setFullYear(startDate.getFullYear() - 1)
        // // 所属期日期控件设置 查一年
        $scope.datePickerConfig = {
            startDate,
            endDate: new Date(),
            format: 'yyyy-mm',
            startView: 'year',
            minView: 'year',
        }
        // 已选择的行数据
        // $scope.selectedRowsData
        $scope.selectedRows = []

        // 查询参数
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                billDateEnd: '',
                billDateStart: '',
                billId: '',
                checkTypeStatus: '',
                managerStatus: '',
                auditResult2: '',
                periodCode: '',
                invoiceAccountStatus: '',
                taxPeriod: '',
            },
        }
        $scope.datePickerConfig1 = {
            startDate,
            endDate: new Date(),
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
        }
        // 请求字典值
        function requestDictData() {
            const typecodeArrStr = '["ivat_invoice_status", "ivat_orig_inv_type","ivat_invoice_is_exist","label_auth_type","ivat_inv_receive_status","check_status","ivat_collect_check_status", "manager_status", "check_type_status", "info_source", "audit_result2", "voucher_account_status","ivat_red_lock_flag"]'
            httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                res.data.value.ivat_collect_check_status.splice(3, 1)
                $scope.dictionary = $.extend($scope.dictionary, res.data.value)
            })
        }

        // 查询列表
        $scope.queryList = function queryList() {
            const { queryParam } = $scope
            queryParam.param.periodCode = queryParam.param.periodCode.replace('-', '')
            httpRequest.post_qryCustomsOfPage(queryParam).then((res) => {
                $scope.collectList = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
                // 查询之后清空已经选择的数据
                $scope.selectedRows = []
            })

            // 总计
            httpRequest.post_getCustomsInvoiceStatics($scope.queryParam.param).then((res) => {
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    invoiceNum: $scope.invoiceNum,
                    totalTaxamt: $scope.totalTaxamt,
                }
            })
        }

        // 字典值
        $scope.dictionary = {
            YES_NO: [
                {
                    enumName: '否',
                    enumCode: '0',
                },
                {
                    enumName: '是',
                    enumCode: '1',
                },
            ],
        }

        $scope.totalItems = 0
        $scope.currentOvatAmt = {}
        $scope.selectedRows = []
        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            let arr = []
            $scope.selectedRows.forEach((i) => {
                $scope.collectList.forEach((item) => {
                    if (item.billId == i.billId) arr.push(item)
                })
            })
            const { totalTaxamt } = getOvatAmtService(arr)
            $scope.invoiceNum = $scope.selectedRows.length
            $scope.totalTaxamt = totalTaxamt
        })

        $scope.searchList = function () {
            $scope.queryList()
        }
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            $scope.queryList()
        }
        $scope.reset = function reset() {
            $scope.queryParam.param = {
                billDateEnd: '',
                billDateStart: '',
                billId: '',
                checkTypeStatus: '',
                managerStatus: '',
                auditResult2: '',
                periodCode: '',
                invoiceAccountStatus: '',
                taxPeriod: '',
            }
        }
        // 自定义查询字段配置
        $scope.customizedConfig = {
            version: 1.26,
            queryConfig: [
                {
                    label: '稽核结果',
                    default: true,
                    selected: true,
                },
                {
                    label: '勾选状态',
                    default: true,
                    selected: true,
                },
                {
                    label: '缴款书号码',
                    default: true,
                    selected: true,
                },
                {
                    label: '管理状态',
                    default: true,
                    selected: true,
                },
                {
                    label: '填发日期',
                    default: true,
                    selected: true,
                },
                {
                    label: '所属期',
                    default: true,
                    selected: true,
                },
                {
                    label: '对账状态',
                    default: true,
                    selected: true,
                },
                {
                    label: '会计期间',
                    default: true,
                    selected: true,
                },
            ],
            table: [
                {
                    label: '勾选状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '对账状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '缴款书号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '填发日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '会计期间',
                    selected: true,
                    default: true,
                },
                {
                    label: '凭证号',
                    selected: true,
                    default: true,
                },
                {
                    label: '税款金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '所属期',
                    selected: true,
                    default: true,
                },
                {
                    label: '稽核结果',
                    selected: true,
                    default: true,
                },
                {
                    label: '管理状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '录入日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '信息来源',
                    selected: true,
                    default: true,
                },
                {
                    label: '勾选人/时间',
                    selected: true,
                    default: true,
                },
            ],
        }

        // 表头排序
        $scope.orderMap = initSortService('customsPaymentParam')
        $scope.selectedHandle = function selectedHandle() {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('customsPaymentParam', JSON.stringify($scope.queryParam))
            $scope.queryList()
        }

        // 初始化ctrl
        function init() {
            $scope.collectList = []
            requestDictData()
            $scope.queryList()
        }
        init()
        /**
         *  打开手动收集弹窗
         */
        function showCollectionDialog() {
            return $uibModal.open({
                templateUrl: 'customs-account-collect-dialog.html',
                controller: collectDialogCtrl,
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-md',
                resolve: {
                    items1() {
                        return $scope.dictionary.ivat_collect_check_status
                    },
                    orgId() {
                        return $scope.currentOrgId
                    },
                    orgList() {
                        return []
                    },
                },
            }).result
        }

        // 采集
        let importinglayer
        // 采集完成
        function done() {
            window.layer.close(importinglayer)
            $scope.queryList()
        }

        function collectFromLocal(param, reSubmitCount) {
            $.jsonp({
                url: `${param.serverAddress}/InvDk`,
                data: {
                    SID: param.sid,
                    SIDParam: param.msg.replace(new RegExp('[+]', 'gm'), '_'),
                },
                timeout: 86400000,
                charset: 'GBK',
                callbackParameter: 'callback',
                success(json) {
                    if (json.retcode === '1') {
                        param.data = json.ResponseStr
                        const saveParam = $.extend({}, $scope.collectParam, {
                            data: json.ResponseStr,
                            batchNo: param.batchNo,
                            reqAuthStatus: param.reqAuthStatus,
                            reqBeginTime: param.reqBeginDate,
                            reqEndTime: param.reqEndDate,
                        })
                        saveFromLocal(saveParam, reSubmitCount)
                    } else {
                        logger.logError(json.retmsg)
                        done()
                    }
                },
                error() {
                    logger.logError('进项服务连接失败')
                    done()
                },
            })
        }

        // 从服务器采集
        function collectFromRemote(param) {
            httpRequest
                .post_saveIvatCollectBatchByRemote(
                    $.extend($scope.collectParam, {
                        sid: param.sid,
                        msg: param.msg,
                        batchNo: param.batchNo,
                        reqAuthStatus: param.reqAuthStatus,
                        reqBeginTime: param.reqBeginDate,
                        reqEndTime: param.reqEndDate,
                        isCustomsPaymentBill: '1',
                    })
                )
                .then(() => {
                    done()
                })
        }
        // 获取采集参数
        function queryCollectParam() {
            // 进项设备类型
            const inputDeviceType = (localStorage.inputDeviceType && JSON.parse(localStorage.getItem('inputDeviceType'))) || {}
            $scope.collectParam.deviceType = inputDeviceType.deviceType
            $scope.collectParam.isCustomsPaymentBill = '1'
            httpRequest.post_getCollectParam($scope.collectParam).then((res) => {
                if (!res.data.success) {
                    return done()
                }
                // reConmmit = 0
                // 返回参数数组（因为有时需调用两个接口）
                res.data.value.forEach((item) => {
                    if (item.serverType === 'local') {
                        collectFromLocal(item, 0)
                    } else {
                        collectFromRemote(item)
                    }
                })
            }, done)
        }

        // 开始采集获取batchNo
        function startCollect() {
            importinglayer = window.layer.msg('正在采集, 请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            queryCollectParam($scope.collectParam)
        }

        // 页面点击采集
        $scope.collect = function collect() {
            if ($scope.isElecTaxBureau) {
                return
            }
            showCollectionDialog().then((collectParam) => {
                $scope.collectParam = collectParam
                startCollect()
            })
        }

        function saveFromLocal(param, reSubmitCount) {
            param.isCustomsPaymentBill = '1'
            httpRequest.post_saveIvatCollectBatch(param).then((res) => {
                const result = res.data.value
                if (res.data.success) {
                    if (result.resultCount < $scope.collectParam.displayLength) {
                        done()
                    } else {
                        $scope.collectParam.displayStart += $scope.collectParam.displayLength
                        queryCollectParam(param)
                    }
                } else if (reSubmitCount <= 3) {
                    // 失败 重新提交 TODO 3次
                    reSubmitCount += 1
                    saveFromLocal(param, reSubmitCount)
                } else {
                    done()
                    logger.logError('保存失败')
                }
            })
        }
    }
}

customsPaymentListCtrl.$inject = ['$scope', 'httpRequest', '$uibModal', '$state', 'logger', 'sweetalert', 'initSortService', 'getOvatAmtService', 'Upload', '$timeout']
export default customsPaymentListCtrl



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/originalAccount/customsPaymentListCtrl.js